import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { getFocusItemDocumentList, setFocusShareDocument, getFilterDocumentListByUuid } from "../../../share-document";
import { connect } from "../../redux";
import { screenFit } from "../function";
import CanvasDraw from "./CanvasDraw";

import { isChatOpen } from "../../../chat";
import PDFViewer from "../../../share-document/components/PDFViewer";
import { translate } from "../../i18n";

const CanvasLayoutStyled = styled.div`
    position: relative;
    background-color: ${props => props.isVod ? "transparent" : "#f7f7f7"};
    overflow: hidden;
    ${props => props.isVod ? `
        position: absolute;
        width: 100%;
    ` : `
        width: 100%;
        height: 100%;
    `}

    .page_container {
        display: flex;
        position: absolute;
        top: 0;
        left: 0;       
        width: 100%;
        height: 100%;
        justify-content: flex-start;
        align-items: flex-start;

        canvas {
            display: inline-flex;
            margin: auto;
        }
    }

    .canvas_container {
        display: flex;
        width: 100%;
        height: 100%;       

        .konvajs-content { 
            margin: ${props => props.isVod ? "0 auto" : "auto"};
            background-color: ${props => props.isVod || !props.isWhiteBoard ? "transparent" : "#fff"};
        }
    }

    &.noDocument {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #808080;
        font-size: 16px;
        flex-direction: column;
        gap: 24px;

        .documet_img {
            width: 32px;
            height: 35px;
            background-position: -641px -143px;
            transform: scale(1.5);
        }
    }

    textarea {
        position: absolute;
        box-sizing: border-box;
        margin: 0;
        background: none;
        outline: none;
        border: none;
        resize: none;
        transform-origin: left top;
        padding: 5px;
    }
`;

function NoDocument({ t }) {
    return (
        <CanvasLayoutStyled className="noDocument">
            <span className="icoImg documet_img" > </span>
            <span>{t("document.resAddDocument")}</span>
        </CanvasLayoutStyled>
    );
}

function CanvasLayout({
    t, dispatch, shareDocumentPermission, expand, isLeftOpen, isWhiteBoard, isVod, vodStyle,
    document, uuid, index, zoom, isWidthFit, rightMenu, resize, refresh,
    handlerSize
}) {
    const tempTextRef = useRef();
    const pdfWrapper = useRef(null);

    const [elementWidth, setElementWidth] = useState(0);
    const [elementHeight, setElementHeight] = useState(0);
    const [canvasWidth, setCanvasWidth] = useState(0);
    const [canvasHeight, setCanvasHeight] = useState(0);
    const [loadImage, setLoadImage] = useState(false);
    const [canvasX, setCanvasX] = useState(0);
    const [canvasY, setCanvasY] = useState(0);
    const [scale, setScale] = useState(zoom);

    useEffect(() => {
        setCanvasX(0);
        setCanvasY(0);
    }, [index, isWidthFit]);

    useEffect(() => {
        setScale(zoom / 100);
    }, [zoom]);

    useEffect(() => {
        setElementSize();
    }, [resize, uuid, rightMenu, expand, isLeftOpen, vodStyle]);

    useEffect(() => {    
        if (isWhiteBoard) {
            let fitStyle;
    
            fitStyle = screenFit( elementWidth, elementHeight, 16, 9, isWidthFit);
            if (isWidthFit === undefined) {
                if (elementHeight < fitStyle.height || elementWidth < fitStyle.width) {
                    fitStyle = screenFit( elementWidth, elementHeight, 16, 9, true);
                }
            }

            setCanvasWidth(fitStyle.width);
            setCanvasHeight(isVod ? fitStyle.height - 41 : fitStyle.height);

            setLoadImage(true);
        }
    }, [document, isWidthFit, elementWidth, elementHeight]);

    const setElementSize = () => {
        if (isVod) {
            setElementWidth(vodStyle.width);
            setElementHeight(vodStyle.height + 41);
        } else {
            if (pdfWrapper && pdfWrapper.current) {
                const elementStyle = pdfWrapper.current.getBoundingClientRect();
                setElementWidth(elementStyle.width);
                setElementHeight(elementStyle.height);
            }
        }
       
    };

    const onFocusDocument = index => {
        dispatch(setFocusShareDocument(uuid, index, false, false));
    }
    return (        
        <CanvasLayoutStyled ref={pdfWrapper} className="nonSelect" isVod={isVod} isWhiteBoard={isWhiteBoard} focusIndex={index}>
            <>
                { document && (shareDocumentPermission || (!shareDocumentPermission && document.shared)) ?
                    <>
                        { !isWhiteBoard && document.complete &&  
                            <PDFViewer 
                                refresh={refresh}
                                canvasX={canvasX}
                                canvasY={canvasY}
                                focusUuid={uuid}
                                focusIndex={index}
                                uuid={document.uuid}
                                page={document.page}
                                scale={scale}
                                isWidthFit={isWidthFit}
                                elementWidth={elementWidth}
                                elementHeight={elementHeight}
                                onFocusDocument={onFocusDocument}
                                setCanvasWidth={setCanvasWidth}
                                setCanvasHeight={setCanvasHeight}
                                setLoadImage={setLoadImage}
                            /> }
                        
                        { loadImage && <CanvasDraw 
                            refresh={refresh}
                            focusUuid={uuid}
                            focusIndex={index}
                            isWhiteBoard={isWhiteBoard}
                            tempTextRef={tempTextRef}
                            canvasStyle={{ width: canvasWidth, height: canvasHeight }}
                            elementWidth={elementWidth}
                            elementHeight={elementHeight}
                            scale={scale}
                            isWidthFit={isWidthFit}
                            canvasX={canvasX}
                            canvasY={canvasY}
                            number={isVod ? 1 : document.count}
                            setCanvasX={setCanvasX}
                            setCanvasY={setCanvasY}
                        /> }

                        <div ref={tempTextRef} style={{ display: "none" }} data-style-width={`${elementWidth}`} data-style-height={`${elementHeight}`}>
                            <textarea  />
                        </div>
                    </> 
                : <NoDocument t={t} /> }
            </>
        </CanvasLayoutStyled>
    );
}

function _mapStateToProps(state, ownProps) {
    const focusItem = ownProps.focusItem ? 
        { ...ownProps.focusItem, list: getFilterDocumentListByUuid(state, ownProps.focusItem.uuid, true) }
        : getFocusItemDocumentList(state, ownProps.isWhiteBoard);

    const isChat = isChatOpen(state);
    const {isOpen: isParticipant} = state["features/participant-right"];
    const { refresh } = state["features/share-document"];
    
    const document = focusItem.list;
    return {
        document: document ? document.page === 'vod' ? ownProps.isVod ? document :  null : ownProps.isVod ? null : document : null,
        uuid: focusItem.uuid,
        index: focusItem.index,
        zoom: state['features/base/canvas'].zoom,
        isWidthFit: state['features/base/canvas'].isWidthFit,
        rightMenu: isChat || isParticipant,
        refresh
    }
}

export default translate(connect(_mapStateToProps)(CanvasLayout));
 